module.exports = __webpack_public_path__ + "img/silver-medal.54a2b848.svg";